module.exports = __webpack_public_path__ + "static/media/triangolo_rosso_agriturismo.a40e3672.svg";